import { render } from "./EditPofilePage.vue?vue&type=template&id=0832ebc6"
import script from "./EditPofilePage.vue?vue&type=script&lang=js"
export * from "./EditPofilePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__